
(function() {
  var result = { translations: { "de": { "i18n": { "duration": { "seconds": "{{ seconds }} Sek.", "minutes": "{{ minutes }} Min.", "hours": "{{ hours }} Std.", "hoursAndMinutes": "{{ hours }} Std. {{ minutes }} Min.", "days": "{{ days }} Tage", "shortForm": { "seconds": "{{ seconds }} Sek.", "minutes": "{{ minutes }} Min.", "hours": "{{ hours }} Std.", "days": "{{ days }} Tage", "hoursAndMinutes": "{{ hours }} Std. {{ minutes }} Min." } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, Durchwahl {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "de": "static-7.911"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.911",
    "ar-eg": "static-7.911",
    "bg": "static-7.911",
    "bn": "static-7.911",
    "ca-es": "static-7.911",
    "cs": "static-7.911",
    "da": "static-7.911",
    "de": "static-7.911",
    "el": "static-7.911",
    "en-gb": "static-7.911",
    "en": "static-7.911",
    "es-mx": "static-7.911",
    "es": "static-7.911",
    "fi": "static-7.911",
    "fr-ca": "static-7.911",
    "fr": "static-7.911",
    "he-il": "static-7.911",
    "hr": "static-7.911",
    "hu": "static-7.911",
    "id": "static-7.911",
    "it": "static-7.911",
    "ja": "static-7.911",
    "ko": "static-7.911",
    "lt": "static-7.911",
    "ms": "static-7.911",
    "nl": "static-7.911",
    "no": "static-7.911",
    "pl": "static-7.911",
    "pt-br": "static-7.911",
    "pt-pt": "static-7.911",
    "ro": "static-7.911",
    "ru": "static-7.911",
    "sk": "static-7.911",
    "sl": "static-7.911",
    "sv": "static-7.911",
    "th": "static-7.911",
    "tl": "static-7.911",
    "tr": "static-7.911",
    "uk": "static-7.911",
    "vi": "static-7.911",
    "x-pseudo": "static-7.911",
    "zh-cn": "static-7.911",
    "zh-hk": "static-7.911",
    "zh-tw": "static-7.911"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:de', {version: 'static-7.911'}); }
})();


